import React from "react";
import {
  IconContainer,
  NotFoundText,
  ReportHere,
  TextWrapper,
  Wrapper
} from "./styles";
import NotFound from "@public/images/icons/not-found.svg";
import ChevronRight from "@public/images/icons/chevron-right-blue.svg";
import ImageContainer from "@components/imageContainer";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import { resolvePath } from "@utils/resolvePath";

interface IVariantNotFound {
  handleModalClick: () => void;
  styles?: React.CSSProperties;
}

const VariantNotFound: React.FC<IVariantNotFound> = ({
  handleModalClick,
  styles
}) => {
  return (
    <>
      <Wrapper styles={styles}>
        <TextWrapper>
          <NotFoundText>Unable to find your vehicle?</NotFoundText>
          <Flex
            flexDirection="row"
            style={{ cursor: "pointer", alignItems: "center" }}
            onClick={handleModalClick}
          >
            <ReportHere>Report here</ReportHere>
            <ChevronRight />
          </Flex>
        </TextWrapper>
        <IconContainer>
          <NotFound />
        </IconContainer>
      </Wrapper>
    </>
  );
};

export default VariantNotFound;
